import Subheading from "plos/src/components/Subheading";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { newsSectionStyles } from "./newsSection.css";
import { INewsContentList } from "./types";

const NewsContainer = ({ title, children }: INewsContentList) => (
  <SurfaceContainer>
    <div className={newsSectionStyles}>
      {title && <Subheading>{title}</Subheading>}
      {children}
    </div>
  </SurfaceContainer>
);

export default NewsContainer;
